import { gettext } from '@eventbrite/i18n';
import React from 'react';
import Banner from './Banner';

export const HEADER = gettext('Do events help you find connection?');

interface SocialConnectionBannerProps {
    handleTracking?: Function;
    trackingParams?: string;
    category?: string;
    domain?: string;
}

const SocialConnectionBanner: React.FunctionComponent<
    SocialConnectionBannerProps
> = (props) => {
    const trackingData = {
        type: 'TRACK_PLAYBOOK_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'PLAYBOOKBannerClick',
                category: props.category,
            },
        },
    };

    return (
        <Banner leftAccentColor="#F05537" style="light" header={HEADER}>
            <span>
                {gettext(
                    'Help us understand how attending events contributes to building social connection by taking a short survey before and after your next event. ',
                )}
                <a
                    onClick={() => {
                        props.handleTracking?.(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={
                        'https://ugeorgia.ca1.qualtrics.com/jfe/form/SV_agHQ1wIV6ExRUwu'
                    }
                >
                    {gettext('Start here')}
                </a>
                .
            </span>
        </Banner>
    );
};

export default SocialConnectionBanner;
